<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="$emit('close')">
                <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn color="success" @click="saveAndClose()">Zapisz</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-alert type="warning" prominent v-if="visitDetails && visitDetails.status == 2">
                          Wizyta została odwołana. Status: {{ getStatusDescription()  }} {{ visitDetails.cancelReason ? 'Powód: ' + visitDetails.cancelReason : '' }}
                        </v-alert>
        <v-stepper non-linear v-model="step" @change="stepChanged">
            <v-stepper-header>
              <template v-for="krok in kroki">
                <v-stepper-step :key="krok.step" :step="krok.step" :editable="krok.user_right_name == '' || $can('do',krok.user_right_name)" :v-if="krok.user_right_name == '' || $can('do',krok.user_right_name)">
                  {{krok.title}}
                </v-stepper-step>
                <v-divider :key="krok.step" :v-if="krok.step != getStepNumber('ZakonczenieWizyty')"></v-divider>
              </template>

            </v-stepper-header>
            <v-stepper-content :step="getStepNumber('TherapistVisitGeneralDetails')">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <TherapistVisitGeneralDetails v-if="visitDetails" :details="visitDetails" @typwizyty="typWizytyUpdate"></TherapistVisitGeneralDetails>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content :step="getStepNumber('Problemy')" v-if="$can('do','POKO_KlienciProblemy')">
              <Problemy :clientid="visitDetails.client_id" v-if="visitDetails && step == getStepNumber('Problemy') && $can('do','POKO_KlienciProblemy')"></Problemy>
            </v-stepper-content>

            <v-stepper-content :step="getStepNumber('PlanyZdrowienia')" v-if="$can('do','POKO_PlanyZdrowienia')">
              <PlanyZdrowienia v-if="visitDetails && getStepNumber('PlanyZdrowienia')" :clientid="visitDetails.client_id"></PlanyZdrowienia>
            </v-stepper-content>
            <v-stepper-content :step="getStepNumber('TherapistVisitProcess')">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <TherapistVisitProcess v-if="visitDetails" :details="visitDetails" @process="processUpdate" :procedures.sync="visitDetails.procedures"></TherapistVisitProcess>
                  </v-col>
                </v-row>
              </v-container>

            </v-stepper-content>
            <v-stepper-content :step="getStepNumber('TherapistVisitRecognition')">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <TherapistVisitRecognition v-if="visitDetails" :details="visitDetails" @recognition="recognitionUpdate" :conditions.sync="visitDetails.conditions"></TherapistVisitRecognition>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content :step="getStepNumber('TherapistVisitRecommendations')">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <TherapistVisitRecommendations v-if="visitDetails" :details="visitDetails" @recommendations="recommendationsUpdate"></TherapistVisitRecommendations>
                  </v-col>
                </v-row>
              </v-container>

            </v-stepper-content>
            <v-stepper-content :step="getStepNumber('ZakonczenieWizyty')">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea outlined v-if="this.visitDetails" label="Uwagi dla recepcji" v-model="visitDetails.notesForReception"></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-stepper-content>
        </v-stepper>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="60" color="success"></v-progress-circular>
        </v-overlay>
        <v-card-actions>
            <v-container fluid>
                <v-row>
                    <v-col cols="6">
                        <v-row>
                            <v-col cols="12">
                                <v-btn color="primary" v-if="step > 1" @click="previousStep">Wstecz</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row>
                            <v-col cols="12" style="text-align: right">
                                <v-btn color="success" v-if="step < kroki.length" @click="nextStep">Dalej</v-btn>
                                <v-btn color="success" v-if="step >= kroki.length" @click="saveAndClose">Zapisz i zakończ</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>

        </v-card-actions>
    </v-card>

</template>

<script>
    import {visitService} from "../../services";
    import swal from "sweetalert";
    import TherapistVisitGeneralDetails from "./TherapistVisitGeneralDetails";
    import TherapistVisitProcess from "./TherapistVisitProcess";
    import TherapistVisitRecognition from "./TherapistVisitRecognition";
    import TherapistVisitRecommendations from "./TherapistVisitRecommendations";
    import * as dayjs from "dayjs";
    import Problemy from "@/components/clients/Problemy";
    import PlanyZdrowienia from "@/components/clients/PlanyZdrowienia.vue";


    export default {
        name: "TherapistVisitEditor",
        components: {
          PlanyZdrowienia,
          Problemy,
            TherapistVisitRecommendations,
            TherapistVisitRecognition, TherapistVisitProcess, TherapistVisitGeneralDetails},
        props: ["visitData", "visible"],
        data() {
            return {
                title: 'Wizyta: ',
                visitid: 0,
                step: 1,
                loading: false,
                visitDetails : null,
                typWizytyUpdated: false,                
            }
        },
        computed: {          
          kroki() {
            let steps = []
            let currentStep = 1
            steps.push({
              step: currentStep,
              component_name: 'TherapistVisitGeneralDetails',
              title: 'Informacje ogólne',
              user_right_name: ''
            });

            if(this.$can('do','POKO_KlienciProblemy'))
            {
              currentStep++;
              steps.push({
                step: currentStep,
                component_name: 'Problemy',
                title: 'Problemy pacjenta',
                user_right_name: 'POKO_KlienciProblemy'
              })
            }
            if(this.$can('do','POKO_PlanyZdrowienia'))
            {
              currentStep++;
              steps.push({
                step: currentStep,
                title: 'Plany terapii i zdrowienia',
                component_name: 'PlanyZdrowienia',
                user_right_name: 'POKO_PlanyZdrowienia'
              })
            }
            currentStep++;
            steps.push({
              step: currentStep,
              component_name: 'TherapistVisitProcess',
              title: 'Przebieg wizyty - badania/zabiegi',
              user_right_name: ''
            });
            currentStep++;
            steps.push({
              step: currentStep,
              component_name: 'TherapistVisitRecognition',
              title: 'Rozpoznanie',
              user_right_name: ''
            });
            currentStep++;
            steps.push({
              step: currentStep,
              component_name: 'TherapistVisitRecommendations',
              title: 'Zalecenia',
              user_right_name: ''
            });
            currentStep++;
            steps.push({
              step: currentStep,
              component_name: 'ZakonczenieWizyty',
              title: 'Zakończenie wizyty',
              user_right_name: ''
            });
            return steps;
          }
        },
        methods: {
            getStatusDescription() {
              if(this.visitDetails.statusSubtype != 0)
              {
                switch(this.visitDetails.statusSubtype)
                {
                  case 1:
                    return 'Odwołana przez pracownika'
                  case 2:
                    return 'Odwołana przez placówkę'
                  case 3:
                    return 'Nieobecność usprawiedliowiona'
                  case 4:
                    return 'Nieobecność nieusprawiedliowiona'
                }
              }
              else
              {
                return 'Wizyta odwołana'
              }
            },
            getStepNumber(component_name)
            {
              return this.kroki.find(x=>x.component_name == component_name).step
            },
            previousStep() {
                let newNum = Number(this.step) - 1
                this.step = newNum
                this.stepChanged(this.step)
            },
            nextStep() {
                let newNum = Number(this.step) + 1

                this.step = newNum
                this.stepChanged(this.step)
            },
            processUpdate(value) {

                this.visitDetails.process = value
            },
            recognitionUpdate(value) {
              this.visitDetails.recognition = value
            },
            recommendationsUpdate(value) {
                this.visitDetails.recommendations = value
            },
            typWizytyUpdate(value) {

              if(value == null) return
              this.typWizytyUpdated = true
              if(value.dlugosc_wizyty > 0)
              {

                if (this.visitDetails.startTime != null) {
                  this.visitDetails.endTime = dayjs(this.visitDetails.startTime)
                      .add(value.dlugosc_wizyty, "minute")
                  let oldVisitDetails = this.visitDetails
                  this.visitDetails = null
                  this.visitDetails = oldVisitDetails
                }
              }

              this.visitDetails.typWizytyTerapeutyId = value.id

            },
            stepChanged(value)
            {
              if(value > 1)
              {
                this.saveData(false)
              }
            },
            saveData(close) {
                this.loading = true
                visitService.UpdateVisitProcess({
                    id: this.visitDetails.visitId,
                    recognition: this.visitDetails.recognition,
                    recommendations: this.visitDetails.recommendations,
                    process: this.visitDetails.process,
                    notesForReception: this.visitDetails.notesForReception
                }).then(() => {
                  if(this.typWizytyUpdated)
                  {
                    visitService.UpdateTypWizytyCzasWizyty({
                      typ_wizyty_id: this.visitDetails.typWizytyTerapeutyId,
                      visit_id: this.visitDetails.visitId
                    }).then(() => {
                      this.loading = false
                      this.typWizytyUpdated = false
                      if(close)
                        this.$emit('close')
                    }).catch((err) => {
                      if (
                          err.response != null &&
                          err.response.data != null &&
                          err.response.data.error != null
                      ) {
                        this.showError(false,err.response.data.error.message)
                      } else {
                        this.showError(false,"Błąd zapisu typu i czasu wizyty.");
                      }
                      this.loading = false
                    })
                  }
                  else
                  {
                    this.loading = false
                    if(close)
                      this.$emit('close')
                  }

                }).catch(() => {
                    this.showError(true,"Błąd zapisu przebiegu wizyty.");
                    this.loading = false
                })
            },
            saveAndClose() {
                this.saveData(true)
            },
            loadData() {
                this.loading = true
                visitService.GetTherapistVisitDetails(this.visitid).then(result => {
                    if(result != null && result.data != null)
                    {
                        this.visitDetails = result.data.result
                        this.title = 'Wizyta: '+this.visitDetails.clientName + ' '+this.visitDetails.clientSurname
                    }
                    else
                    {
                        throw 'error'
                    }
                    this.loading = false
                }).catch(() => {

                    this.showError(true,"Błąd pobierania informacji o wizycie.");
                    this.loading = false
                })
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            }
        },
        watch: {
            visitData: {
                immediate: true,
                handler(newval) {
                    if (newval != null) {
                        if (newval.Id !== undefined && newval.Id != null && newval.Id > 0) {
                            this.visitid = newval.Id;
                            this.loadData();
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>